"use strict";

import { setTimeout } from "core-js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper/bundle';
gsap.registerPlugin(ScrollTrigger);



window.addEventListener(
  'load',
  () => {
    setTimeout(function() {
      scrollElements();
    },
    500);
  },
  false
);


function scrollElements() {
  ScrollTrigger.matchMedia({
    "(min-width: 768px)": function() {
      // 画像固定
      const fix = document.querySelectorAll(".fix-content");
      fix.forEach((item) => {
        ScrollTrigger.create({
          trigger: '.people-single-cont__inner',
          start: 'top top',
          end: 'bottom bottom',
          pin: item
        });
      });
      // 画像切り替え
      const section = document.querySelectorAll(".people-single-cont__sec");
      section.forEach((item) => {
        ScrollTrigger.create({
          trigger: item,
          start: "top 1%",
          toggleClass: {targets: ".people-single-cont__fig.hidden-sp", className: "active" + item.dataset.section},
          toggleActions: 'play none none reverse'
        });
      });
      // コピー上の画像表示
      ScrollTrigger.create({
        trigger: ".people-single-cont__main--trigger",
        start: "top center",
        once: true,
        onEnter: () => {
          document.querySelector(".people-single-cont__img--01").classList.add("on");
        },
      });
    },

    // 768px未満
    "(max-width: 767px)": function() {

      ScrollTrigger.create({
        trigger: (".people-single-cont__fig--01.hidden-pc"),
        start: "top top",
        endTrigger: (".people-single-cont__sec--sp"),
        end: "bottom bottom",
        pin: (".people-single-cont__fig--01.hidden-pc"),
        pinSpacing: false,
      });

      ScrollTrigger.create({
        trigger: (".people-single-cont__fig--01.hidden-pc"),
        start: "top top",
        once: true,
        onEnter: () => {
          document.querySelector(".people-single-cont__fig--01.hidden-pc").classList.add("on");
        },
      });


      const block = document.querySelectorAll(".people-single-cont__base");
      block.forEach((item) => {
        ScrollTrigger.create({
          trigger: item,
          start: "top top",
          endTrigger: item,
          end: "bottom bottom",
          pin: item.querySelector(".people-single-cont__circles.hidden-pc"),
          pinSpacing: false,
        });
      });

      // 背景画像固定
      const section = document.querySelectorAll(".people-single-cont__sec:not(.people-single-cont__sec--01)");
      section.forEach((item) => {
        ScrollTrigger.create({
          trigger: item.querySelector(".people-single-cont__fig"),
          start: "top top",
          endTrigger: item,
          end: "bottom bottom",
          pin: item.querySelector(".people-single-cont__fig"),
          pinSpacing: false,
        });
      });
      // 白べたのトリガー
      const section02 = document.querySelectorAll(".people-single-cont__sec");
      section02.forEach((item) => {
        ScrollTrigger.create({
          trigger: item.querySelector(".people-single-cont__blc"),
          start: "top+=10% top",
          endTrigger: item,
          end: "bottom top",
          toggleClass: {targets: item, className: "is-active"},
          toggleActions: 'play none none reverse'
        });
      });
      // message部分
      ScrollTrigger.create({
        trigger: (".people-single-message"),
        start: "top top",
        endTrigger: (".people-single-message"),
        end: "bottom bottom",
        pin: (".people-single-message__bg"),
        pinSpacing: false,
      });
      // message白ベタ
      ScrollTrigger.create({
        trigger: (".people-single-message"),
        start: "top+=10% top",
        endTrigger: (".people-single-message"),
        end: "bottom top",
        toggleClass: {targets: ".people-single-message", className: "is-active"},
        toggleActions: 'play none none reverse'
      });
    }
  });
}



let swipeOption = {
  autoplay: {
    delay: 5000,
  },
  loop: true,
  slidesPerView: "auto",
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
}

let swiper =  new Swiper('.swiper-container', swipeOption);


document.querySelector(".swiper-container").addEventListener(
  "mouseenter",
  () => {
    swiper.autoplay.stop();
  },
  false
);

document.querySelector(".swiper-container").addEventListener(
  "mouseleave",
  () => {
    swiper.autoplay.start();
  },
  false
);
